import { useState } from "react";
import { api, errText, mediaUrl } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { X, Rss, PlusCircle, Music2, Play, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Share a VStar Music track or VStar TV video to the VirtuStars feed or your Story (internal).
// entity: { kind: "track" | "video", id, title, cover, author }
export function ShareToVSModal({ entity, onClose }) {
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const isTrack = entity.kind === "track";

  const done = (msg) => { toast.success(msg); window.dispatchEvent(new Event("vs:refresh")); onClose(); };

  const shareFeed = async () => {
    setBusy(true);
    try {
      const body = { text: caption, ...(isTrack ? { music_id: entity.id } : { video_id: entity.id }) };
      await api.post("/posts", body);
      done("Shared to your feed");
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const shareStory = async () => {
    setBusy(true);
    try {
      await api.post("/stories", {
        media_url: entity.cover || null, media_type: "repost", text: caption,
        shared_ref: { kind: entity.kind, id: entity.id, author: entity.author, title: entity.title, cover: entity.cover },
      });
      done("Shared to your Story");
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="share-to-vs-modal">
      <div className="surface rounded-2xl p-5 w-full max-w-sm relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-white" data-testid="share-vs-close"><X size={18} /></button>
        <div className="flex items-center gap-2 mb-3">{isTrack ? <Music2 size={18} className="text-eblue" /> : <Play size={18} className="text-eblue" />}<h3 className="font-display font-bold text-lg">Share to VirtuStars</h3></div>
        <div className="flex items-center gap-3 surface-2 rounded-xl p-2.5 mb-3 border border-white/10">
          {entity.cover && <img src={mediaUrl(entity.cover)} alt="" className={`${isTrack ? "w-12 h-12" : "w-16 h-10"} rounded-lg object-cover shrink-0`} />}
          <div className="min-w-0"><div className="text-sm font-semibold truncate">{entity.title}</div><div className="text-xs text-muted-foreground truncate">{isTrack ? "VStar Music" : "VStar TV"} · {entity.author?.display_name}</div></div>
        </div>
        <Textarea value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Say something… (optional)" className="surface-2 border-white/10 min-h-[64px] mb-3" data-testid="share-vs-caption" />
        <div className="grid grid-cols-2 gap-2">
          <Button onClick={shareFeed} disabled={busy} className="btn-blue rounded-xl" data-testid="share-vs-feed-btn">{busy ? <Loader2 size={15} className="animate-spin" /> : <><Rss size={15} className="mr-1.5" />To Feed</>}</Button>
          <Button onClick={shareStory} disabled={busy} variant="outline" className="rounded-xl border-white/15" data-testid="share-vs-story-btn"><PlusCircle size={15} className="mr-1.5" />To Story</Button>
        </div>
      </div>
    </div>
  );
}
